import { localizeWithPath } from '../../../../nls.js';
import { RawContextKey, ContextKeyExpr } from '../../../../platform/contextkey/common/contextkey.js';
const _moduleId = "vs/workbench/contrib/tasks/common/taskService";
const CustomExecutionSupportedContext = ( (new RawContextKey('customExecutionSupported', false, ( localizeWithPath(
  _moduleId,
  0,
  "Whether CustomExecution tasks are supported. Consider using in the when clause of a \'taskDefinition\' contribution."
)))));
const ShellExecutionSupportedContext = ( (new RawContextKey('shellExecutionSupported', false, ( localizeWithPath(
  _moduleId,
  1,
  "Whether ShellExecution tasks are supported. Consider using in the when clause of a \'taskDefinition\' contribution."
)))));
const TaskCommandsRegistered = ( (new RawContextKey('taskCommandsRegistered', false, ( localizeWithPath(_moduleId, 2, "Whether the task commands have been registered yet")))));
const ProcessExecutionSupportedContext = ( (new RawContextKey('processExecutionSupported', false, ( localizeWithPath(
  _moduleId,
  3,
  "Whether ProcessExecution tasks are supported. Consider using in the when clause of a \'taskDefinition\' contribution."
)))));
const ServerlessWebContext = ( (new RawContextKey('serverlessWebContext', false, ( localizeWithPath(_moduleId, 4, "True when in the web with no remote authority.")))));
const TaskExecutionSupportedContext = ( (ContextKeyExpr.or(
   (ContextKeyExpr.and(ShellExecutionSupportedContext, ProcessExecutionSupportedContext)),
  CustomExecutionSupportedContext
)));
export { CustomExecutionSupportedContext, ProcessExecutionSupportedContext, ServerlessWebContext, ShellExecutionSupportedContext, TaskCommandsRegistered, TaskExecutionSupportedContext };
